import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import Spinner from "./modules/spinner";
import "./assets/scss/style.scss";
import "./assets/custom/styles.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

//const App = lazy(() => import("./app"));
const App = lazy(
  () =>
    new Promise((resolve) => {
      setTimeout(() => resolve(import("./modules/app")), 1000);
    }),
);
ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_KEY}>
    <Suspense fallback={<Spinner />}>
      <App />
    </Suspense>
  </GoogleOAuthProvider>,
  document.getElementById("root"),
);
